export const MUI_TAB= {
    SELECTED:{
        TAB_NAME_COLOR: "#027A48",
        BACKGROUND_COLOR: "#ECFDF3",
        HOVER_COLOR: "#D1FADF",
        INDICATOR_COLOR: "#027A48",
    }

};

export const MUI_TOOLTIP = {
    TOOLTIP_BACKGROUND_COLOR: "#fff",
    TOOLTIP_COLOR: "#000",
    TOOLTIP_BOX_SHADOW: "0 4px 24px 0 rgba(0,59,157,0.10), 0 1.5px 6px 0 rgba(0,0,0,0.08)",
    TOOLTIP_BORDER_RADIUS: 10,
    TOOLTIP_FONT_SIZE: 12,
    TOOLTIP_PADDING: "10px 16px",
    TOOLTIP_LETTER_SPACING: 0.1,
    TOOLTIP_FONT_FAMILY: "inherit",
};

export const MUI_MENU_ITEM = {
    SELECTED:{
        BACKGROUND_COLOR: "#066235",
        COLOR: "#fff",
        HOVER_COLOR: "#066235",
    },
    UNSELECTED:{
        BACKGROUND_COLOR: "#e5e7eb",
        COLOR: "#000",
        HOVER_COLOR: "#e5e7eb",
    },
};
export const MUI_STEPPER = {
    CONNECTOR:{
        LINE_BACKGROUND_COLOR: "#e5e7eb",
        ACTIVE_LINE_COLOR: "#003B9D",
        COMPLETED_LINE_COLOR: "#066235",
    },
};